"use strict"; // eslint-disable-next-line no-extend-native

require("core-js/modules/es6.array.filter");

Array.prototype.filterNil = function () {
  return this.filter(function (i) {
    return i !== null && i !== undefined;
  });
};